export const STORAGE_KEY_ACCESS_TOKEN = 'auth.access_token'
export const STORAGE_KEY_REFRESH_TOKEN = 'auth.refresh_token'
export const STORAGE_KEY_THEME = 'app.theme'
